import Link from "next/link";

const TrySeozastCTA = () => {
  return (
    <div className="text-center py-6">
      <Link
        href="/register"
        className="inline-block bg-emerald-500 text-white hover:text-white font-bold text-lg px-6 py-3 rounded-lg hover:bg-emerald-600 transition-colors duration-200"
        rel="nofollow"
      >
        Try SEOZast for Free
      </Link>
    </div>
  );
};

export default TrySeozastCTA;